import { GetterTree } from 'vuex';

export const getters = {
    getCurrentAudio: state => state.currentAudio
};
